'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Context = require('../Context.js');

/* ----------------------- useInformed ----------------------- */
function useInformed() {
  return React.useContext(Context.InformedContext);
}

exports.useInformed = useInformed;
